import React from "react";
import { elementType } from "prop-types";

import Typography from "../shared/Typography";

const ErrorMessage = ({ children }) => (
  <Typography className="text-red text-xl text-center py-4">
    {children}
  </Typography>
);

ErrorMessage.propTypes = {
  children: elementType,
};

export default ErrorMessage;
